import qs from 'qs';
import axios from 'axios';
import { requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';
import GetOperationsFromXLSFile from '@/application/services/readers/get-operations-xls-file';
import Bottleneck from 'bottleneck';

const getOptions = () => ({ headers: authenticationService.authHeader() });
export const paramsSerializer = params => {
  return qs.stringify(params);
};

export const setNoLateChargesUntil = async (operationId, paymentNumber, noLateChargesUntil) => {
  return (await requestFunnel.patch(`operations/${operationId}`, { paymentNumber, noLateChargesUntil }, getOptions())).data;
};

export const getSummarizedOperationsByPaymentsInvestorIds = async (investorsIds, actualDueDate) => {
  const options = getOptions();
  options.params = { investorsIds, actualDueDate };
  // options.paramsSerializer = paramsSerializer;
  const response = await requestFunnel.get('operations/summarized', options);
  if (response.data) {
    response.data.sort((a, b) => (a.companyOperationId > b.companyOperationId ? 0 : -1));
  }
  return response.data;
};

export const getPaymentsByOperationIdAndInvestorsIds = async (operationId, investorsIds) => {
  const options = getOptions();
  options.params = { investorsIds };
  options.paramsSerializer = paramsSerializer;
  const response = await requestFunnel.get(`operations/${operationId}/payments`, options);
  return response.data;
};

export const getOperationsByClientId = async clientId => {
  const response = await requestFunnel.get(`operations/clients/${clientId}`, getOptions());
  return response.data;
};

export const setOperationPaymentsInflationaryUpperBound = async (operationId, firstPaymentNumber, lastPaymentNumber, newInflationaryUpperBound) => {
  const response = await requestFunnel.patch(`operations/inflationary-upper-bound/${operationId}`, { firstPaymentNumber, lastPaymentNumber, newInflationaryUpperBound }, getOptions());
  return response.data;
};

export const getOperations = async (documentsPerPage, pageNumber, cancelExecutor) => {
  const options = getOptions();
  options.params = { documentsPerPage, pageNumber };
  options.cancelToken = new axios.CancelToken(cancelExecutor);
  return (await requestFunnel.get('operations', options)).data;
};

export const getOperation = async operationId => {
  const options = getOptions();
  return (await requestFunnel.get(`operations/${operationId}`, options)).data;
};

export const findOperationsBySearchString = async (searchString, cancelExecutor, searchBar = true, documentsPerPage = 10000, pageNumber = 1, numberOfDocuments = 0, operationType = 'ALL') => {
  const cancelToken = new axios.CancelToken(cancelExecutor);
  const options = getOptions();
  options.params = { searchString, documentsPerPage, pageNumber };
  if (operationType && operationType !== 'ALL') {
    options.params.operationType = operationType;
  }
  // Cuándo se navega con paginación por todas las operaciones
  // Mayor a uno, para dejar afuera el caso de buscar la operación de 1 cliente
  if (!searchString && numberOfDocuments > 1) {
    options.params.numberOfDocuments = numberOfDocuments;
  // Cuándo buscamos varias operaciones en el input o una, siempre queremos del backend la primera página de los resultaods.
  } else if (searchString) { options.params.pageNumber = 1; }
  options.cancelToken = cancelToken;
  const result = (await requestFunnel.get('operations', options)).data;
  return searchBar ? result.operations : result;
};

export const getOperationsFromXLSFile = (file, country) => {
  const reader = new GetOperationsFromXLSFile();
  return reader.process(file, country);
};

export const createBulkOperations = async operations => {
  const options = getOptions();
  return (await requestFunnel.post('operations/bulk', { operations }, options)).data;
};

export const createBulkOperationsLimited = async (operations, currentOperation = {}) => {
  const limiter = new Bottleneck({ maxConcurrent: 5, minTime: 1000 });
  const options = getOptions();
  const wrappedPost = limiter.wrap(async operation => {
    const endpoint = 'operations/bulk';
    // eslint-disable-next-line no-param-reassign
    currentOperation.companyOperationId = operation.companyOperationId;
    return (await requestFunnel.post(endpoint, { operations: [operation] }, options)).data;
  });
  const promises = operations.map(operation => wrappedPost(operation));
  const ServiceResponses = await Promise.allSettled(promises);
  const result = {
    successes: 0,
    failures: 0,
    requests: 0,
    responses: [],
    errors: []
  };
  ServiceResponses.forEach(serviceResponse => {
    const { successes, failures, errors, requests, responses } = serviceResponse.value || {};
    result.successes += successes || 0;
    result.failures += failures || 0;
    result.requests += requests || 0;

    const { status } = serviceResponse;
    const response = (responses || [])[0];
    const error = (errors || [])[0];

    if (status === 'fulfilled' && successes) result.responses.push(Object.assign(response, { success: successes }));
    else if (status === 'fulfilled' && error) result.errors.push(error);
    else if (status === 'rejected') {
      const reasonMessage = serviceResponse.reason.message;
      const dataMessage = serviceResponse.reason.response?.data?.message;
      result.errors.push(dataMessage || reasonMessage);
    }
  });
  return result;
};

export const updateOperationState = async (operationId, reason, enableOrDisableOperation, userState, email, clientId) => {
  const options = getOptions();
  return (await requestFunnel.patch(`operations/change-operation-state/${operationId}`, { reason, enableOrDisableOperation, userState, email, clientId }, options)).data;
};

export const getSummaryOperations = async types => {
  const options = getOptions();
  options.params = { types };
  return (await requestFunnel.get('operations/summary-operations', options)).data;
};
